"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var immer_1 = __importDefault(require("immer"));
var redux_1 = require("redux");
function combineReducersWithImmer(reducers) {
    var reducersWithImmer = {};
    var _loop_1 = function (key) {
        var reducerFn = reducers[key];
        reducersWithImmer[key] = function (state, payload) {
            return typeof state === 'object'
                ? immer_1.default(state, function (draft) {
                    var next = reducerFn(draft, payload);
                    if (typeof next === 'object')
                        return next;
                })
                : reducerFn(state, payload);
        };
    };
    // reducer must return value because literal don't support immer
    for (var _i = 0, _a = Object.keys(reducers); _i < _a.length; _i++) {
        var key = _a[_i];
        _loop_1(key);
    }
    return redux_1.combineReducers(reducersWithImmer);
}
// rematch plugin
var immerPlugin = function () { return ({
    config: {
        redux: {
            combineReducers: combineReducersWithImmer,
        },
    },
}); };
exports.default = immerPlugin;
//# sourceMappingURL=index.js.map